var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnSettingsHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35352 0.75L9.62012 2.56543L9.68359 2.99121L10.083 3.15234C10.5175 3.32679 10.9277 3.55723 11.3018 3.83887L11.6357 4.09082L12.0254 3.93848L13.8018 3.24414L15.1387 5.49219L13.6562 6.62012L13.3037 6.8877L13.3682 7.32617C13.4342 7.77336 13.4342 8.2286 13.3682 8.67578L13.3037 9.11328L13.6562 9.38184L15.1357 10.5078L13.7998 12.7559L12.0225 12.0625L11.6348 11.9111L11.3018 12.1592C10.9246 12.4403 10.5129 12.6722 10.0771 12.8496L9.67969 13.0117L9.61816 13.4365L9.35449 15.2334L7.24414 15.1465L7.38281 15.25H6.65137L6.38379 13.4346L6.32129 13.0068L5.9209 12.8467L5.59961 12.7061C5.28401 12.5547 4.98391 12.3724 4.7041 12.1611L4.36914 11.9082L3.97949 12.0605L2.20215 12.7549L0.865234 10.5068L2.3457 9.38086L2.69824 9.1123L2.63281 8.67383C2.5668 8.22675 2.56677 7.77227 2.63281 7.3252L2.69824 6.88672L2.3457 6.61914L0.864258 5.49219L2.20117 3.24414L3.97949 3.93848L4.36621 4.08984L4.69922 3.8418C4.98284 3.63096 5.28589 3.44766 5.60352 3.29395L5.92578 3.15039L6.32129 2.98828L6.38379 2.56543L6.65137 0.75H9.35352Z",
    stroke: "#4B68CF",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00001,
    cy: 7.99965,
    r: 2.88636,
    stroke: "#4B68CF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnSettingsHover);
export default __webpack_public_path__ + "static/media/icn_btn_settings_hover.76f8ede58d54762e70e01993a347cc26.svg";
export { ForwardRef as ReactComponent };